import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/checkbox';

@Component({
  templateUrl: './checkbox.component.html'
})
export class CheckboxComponent implements OnInit {

  	code = Code;
  	selectedCities: string[] = [];
    selectedCategories: string[] = ['Technology', 'Sports'];
    checked: boolean = false;
    
	parameters: any[];
	eventHeader: any[];
	eventValue: any[];
	styleHeader: any[];
	styleValue: any[];
	items: any[]; 
	headers: any[];
	selectedCar3: string;
    groupedCars: any[];
    methodsHeader: any[];
    methodsValue: any[];

  constructor() { }

  ngOnInit() {
  	
  	this.parameters = [
  		
        {name: "name",type: "string",default: "null",des: "复选框组的名称。"},
        {name: "value",type: "any",default: "null ",des: "复选框的值。"},
        {name: "label",type: "string",default: "null ",des: "复选框标签。"},
        {name: "disabled",type: "boolean",default: "false ",des: "当存在时，它指定该元素应该被禁用。"},
        {name: "binary",type: "boolean",default: "false",des: "允许选择布尔值而不是多个值。"},
        {name: "tabindex",type: "number",default: "null ",des: "列表中元素的索引"},
        {name: "inputId",type: "string",default: "null",des: "焦点输入的标识符，以匹配为下拉定义的标签。"},
        {name: "style",type: "object",default: "null",des: "组件的内联样式。"},
        {name: "styleClass",type: "string",default: "null",des: "组件的样式类。"},
  		{name: "labelStyleClass",type: "string",default: "null",des: "标签样式类。"}
    ];
    
    this.headers = [
        {name : "名字"},
        {name : "类型"},
        {name : "默认"},
        {name : "描述"}
    ];

    this.eventHeader = [
    	{name : "名字"},
        {name : "参数"},
        {name : "描述"}
    ];

    this.eventValue = [
    	{name : "onChange",param : "检查：布尔值表示复选框的新状态。",event :"在“复选框”中单击“调用”。" }
    ];

   
    this.styleHeader = [
    	{name : "名字"},
        {name : "元素"}
    ];

    this.styleValue = [
    	{name : "ui-chkbox",el : "容器元素。"},
    	{name : "ui-chkbox-box",el : "图标容器。"},
    	{name : "ui-chkbox-icon",el : "图标元素。"},
    	{name : "ui-chkbox-label",el : "标签元素。"},
    	{name : "ui-label-active",el : "选中状态的标记元素。"},
    	{name : "ui-label-focus",el : "聚焦状态的标记元素。"},
    	{name : "ui-label-disabled",el : "禁用状态的标签元素。"}
    ];
    this.groupedCars = [
        {
            label: 'Germany', value: 'germany.png', 
            items: [
                {label: 'Audi', value: 'Audi'},
                {label: 'BMW', value: 'BMW'},
                {label: 'Mercedes', value: 'Mercedes'}
            ]
        },
        {
            label: 'USA', value: 'usa.png', 
            items: [
                {label: 'Cadillac', value: 'Cadillac'},
                {label: 'Ford', value: 'Ford'},
                {label: 'GMC', value: 'GMC'}
            ]
        },
        {
            label: 'Japan', value: 'japan.png', 
            items: [
                {label: 'Honda', value: 'Honda'},
                {label: 'Toyota', value: 'Toyota'}
            ]
        }
    ];
  }

}



// WEBPACK FOOTER //
// ./src/app/view/checkbox/checkbox.component.ts